import React from 'react';

// eslint-disable-next-line react/display-name
export const Image = React.forwardRef(({ src, alt, ...props }, ref) => (
  <img ref={ref} src={src} alt={alt} {...props} />
));
